import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const USER_GROUP_LIST_ITEM_CLASS_NAME = 'UserGroupListItem';
export const USER_GROUP_LIST_ITEM_CLASS_SLOTS: Array<
	keyof UserGroupListItemClasses
> = ['root'] as const;

export type UserGroupListItemClassSlot =
	(typeof USER_GROUP_LIST_ITEM_CLASS_SLOTS)[number];

export interface UserGroupListItemClasses {
	root: string;
	hasSecondaryLabel: string;
	isActive: string;
}

export type UserGroupListItemClassKey = keyof UserGroupListItemClasses;

export const getUserGroupListItemUtilityClass = (slot: string) =>
	generateUtilityClass(
		USER_GROUP_LIST_ITEM_CLASS_NAME,
		slot as UserGroupListItemClassSlot,
	);

export const userGroupListItemClasses: UserGroupListItemClasses =
	generateUtilityClasses(
		USER_GROUP_LIST_ITEM_CLASS_NAME,
		USER_GROUP_LIST_ITEM_CLASS_SLOTS.concat(['hasSecondaryLabel', 'isActive']),
	);

export default userGroupListItemClasses;
